import { render, staticRenderFns } from "./brandAdd.vue?vue&type=template&id=76fccc96&"
import script from "./brandAdd.vue?vue&type=script&lang=js&"
export * from "./brandAdd.vue?vue&type=script&lang=js&"
import style0 from "./brandAdd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports